
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";
import rules from "@/services/helpers/validation-rules";

export default Vue.extend({
  name: "Edit",

  data: () => ({
    rules,
    model: {} as any,
    errorMessages: {} as { [value: string]: Array<string> }
  }),

  async beforeRouteEnter(to, from, next) {
    try {
      const item = await API.banks().getForEdit(Number(to.params.id));
      next(vm => {
        vm.model = item;
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    async submit(): Promise<void> {
      try {
        if ((this.$refs.form as any).validate()) {
          await this.$API
            .banks()
            .edit(Number(this.$route.params.id), this.model);
          await this.$router.push("/banks");
          await this.$store.dispatch(
            "alert/showSuccess",
            this.$t("global_alert.successful_edit")
          );
        }
      } catch (e) {
        if (e.hasOwnProperty("errors")) {
          this.errorMessages = e.errors;
          setTimeout(() => {
            this.errorMessages = {};
          }, 2000);
        }
        await this.$store.dispatch("alert/showError", e.message);
      }
    }
  }
});
